module.exports = __webpack_public_path__ + "img/bin.315c4d4d.svg";